export const css = {
	root: '_3i50B4lJ',
	pressed: '_1RnF5avL',
	label: 'L3Jtzdum',
	disabled: '_2KlaYsr0',
	' _key': 'afcpe-theme/dojo/raised-button'
};

export default css;
